import { render } from "./CustomAttributes.vue?vue&type=template&id=52babf82"
import script from "./CustomAttributes.vue?vue&type=script&lang=js"
export * from "./CustomAttributes.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__